import React from 'react';

import { Box, Typography } from '@mui/material';

type Props = {
  id: string;
  externalId: string;
};

export default function CabinColumnDetails(props: Props) {
  return (
    <Box display="flex" flexDirection="column">
      <Typography>
        <b>External ID: </b>
        {props.externalId}
      </Typography>
      <Typography>{props.id}</Typography>
    </Box>
  );
}
